import { addCommasToNumber, DataItem, Texto } from '@gravitate-js/excalibrr'
import { titleCase } from '@utils/general'
import { Col, Row } from 'antd'
import React from 'react'

interface DriverDropOverrideDetailsProps {
  details: Record<string, Record<string, number>>
  detailKeys: string[]
}

export function DriverDropOverrideDetails({ details, detailKeys }: DriverDropOverrideDetailsProps) {
  return detailKeys?.map((key) => {
    return (
      <div className='details-container'>
        <Row key={key} flex justify='space-between'>
          <Col span={24}>
            <Texto weight='bold' className='mt-3'>
              Tank ID {key}:
            </Texto>
          </Col>

          {Object.entries(details[key]).map(([detailKey, value]) => {
            return (
              <Col key={detailKey} span={12}>
                <DataItem label={titleCase(detailKey)}>{addCommasToNumber(value, 0)}</DataItem>
              </Col>
            )
          })}
        </Row>
      </div>
    )
  })
}
